import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EyeSlashFill } from 'react-bootstrap-icons';
import { endImpersonation } from '../../utils/api';
import { endImpersonationAction, authentication, setViewMode } from '../../redux/actions';

const clearClientSession = () => {
  try {
    sessionStorage.removeItem('skusavvy_client_token');
    sessionStorage.removeItem('skusavvy_impersonation');
  } catch (e) {}
  document.cookie = 'SKUSAVVY=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax';
};

function ImpersonationBanner() {
  const { isImpersonating, previousViewMode } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleEndSession = async () => {
    const restoreMode = previousViewMode ?? 'super_admin';
    try {
      await endImpersonation();
    } catch (e) {}
    clearClientSession();
    dispatch(endImpersonationAction());
    dispatch(setViewMode(restoreMode));
    await dispatch(authentication());
    navigate('/dashboard');
  };

  return (
    <div className="impersonation-banner" role="alert">
      <div className="impersonation-banner__content">
        <EyeSlashFill className="impersonation-banner__icon" aria-hidden="true" />
        <span className="impersonation-banner__text">
          Client view active — this session expires in 1 hour
        </span>
      </div>
      <div className="impersonation-banner__actions">
        <button type="button" className="impersonation-banner__back-btn" onClick={handleEndSession}>
          ← Back to Admin
        </button>
        <button type="button" className="impersonation-banner__end-btn" onClick={handleEndSession}>
          End Session
        </button>
      </div>
    </div>
  );
}

export default ImpersonationBanner;
